import { ApiModel } from '@composable-api/api.model'
import { ProductModel } from './product.model'
import { ProductVariationModel } from './product-variation.model'

interface Attributes {
    [ProductVisitModel.ATTR_ID]: number
    [ProductVisitModel.ATTR_LAST_VISITED_AT]: string
}

interface Embeds {
    [ProductVisitModel.EMBED_PRODUCT]?: ProductModel
}

export class ProductVisitModel extends ApiModel<Attributes, Embeds> {
    static key = 'ProductVisitModel'

    static readonly ATTR_ID = 'id'
    static readonly ATTR_LAST_VISITED_AT = 'last_visited_at'

    static readonly EMBED_PRODUCT = 'product'

    get id() {
        return this._getAttribute(ProductVisitModel.ATTR_ID)
    }
    get lastVisitedAt() {
        return this._getAttribute(ProductVisitModel.ATTR_LAST_VISITED_AT)
    }

    get product() {
        return this._getEmbed(ProductVisitModel.EMBED_PRODUCT, ProductModel)
    }
}
